import { useLocalization } from "@fluent/react";
import { ContentCard } from "@narmi/design_system";
import { NeedBudgetIllustration } from "./NeedBudgetIllustration";
import { ReadyToGoIllustration } from "./ReadyToGoIllustration";
import styles from "./SelectedCar.module.css";

type VehicleStatusCardsVariant = "default" | "noRefinance";

interface VehicleStatusCardsProps {
  hasVehicleSelected: boolean | undefined;
  onClickReadyToGo: () => void;
  onClickStillLooking: () => void;
  readyTitle: string;
  readyDescription: string;
  lookingTitle: string;
  lookingDescription: string;
  showSectionLabel?: boolean;
  variant?: VehicleStatusCardsVariant;
}

function VehicleStatusCards({
  hasVehicleSelected,
  onClickReadyToGo,
  onClickStillLooking,
  readyTitle,
  readyDescription,
  lookingTitle,
  lookingDescription,
  showSectionLabel = false,
  variant = "default",
}: VehicleStatusCardsProps) {
  const { l10n } = useLocalization();
  const isNoRefinance = variant === "noRefinance";
  const cardsClassName = isNoRefinance
    ? styles.noRefinanceOptionCards
    : styles.pickedOutCarOptionCards;
  const contentClassName = isNoRefinance ? styles.noRefinanceOptionCardContent : undefined;
  const descriptionClassName = isNoRefinance
    ? "fontSize--xs fontColor--secondary"
    : "margin--top--xxs fontSize--xs fontColor--secondary";
  const descriptionStyle = isNoRefinance ? undefined : { marginBottom: "0px" };

  return (
    <div className={showSectionLabel ? styles.vehicleStatusSection : undefined}>
      {showSectionLabel && (
        <div className="fontSize--xs fontWeight--bold fontColor--secondary">
          {l10n.getString("auto-loan-selected-car-vehicle-status", null, "VEHICLE STATUS")}
        </div>
      )}
      <div className={cardsClassName}>
        <ContentCard
          kind="toggle"
          onClick={onClickReadyToGo}
          radiusSize="l"
          isSelected={hasVehicleSelected === true}
        >
          <div className={contentClassName}>
            {isNoRefinance && <ReadyToGoIllustration />}
            <div className="fontColor--heading fontSize--m fontWeight--bold">{readyTitle}</div>
            <p className={descriptionClassName} style={descriptionStyle}>
              {readyDescription}
            </p>
          </div>
        </ContentCard>
        <ContentCard
          kind="toggle"
          onClick={onClickStillLooking}
          radiusSize="l"
          isSelected={hasVehicleSelected === false}
        >
          <div className={contentClassName}>
            {isNoRefinance && <NeedBudgetIllustration />}
            <div className="fontColor--heading fontSize--m fontWeight--bold">{lookingTitle}</div>
            <p className={descriptionClassName} style={descriptionStyle}>
              {lookingDescription}
            </p>
          </div>
        </ContentCard>
      </div>
    </div>
  );
}

export { VehicleStatusCards };
